export default __webpack_public_path__ + "static/f28-67decad91cea217466ba0390314044a9.svg";